export function getBookingResponseDataFromStorage(): any {
  try {
    return JSON.parse(localStorage.getItem("bookingResponseDataStorage") || "null");
  } catch {
    return null;
  }
}
